<template>
  <div class="py-4">
    <div v-if="saving">
      <div class="d-flex justify-content-center align-items-center" style="height: 200px;">
        <b-spinner label="Loading..." variant="primary" style="width: 3rem; height: 3rem;"></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group d-flex" >
        <b-form-checkbox v-model="visible" @change="updateField()" switch class="mt-n4" />
      </div>
      <div class="row" v-if="visible || !showIfVisible">
        <div class="col-md-12">
          <div class="form-group">
            <label>Title</label>
            <input
              type="text"
              class="form-control"
              placeholder="Title"
              v-model.trim="title"
              @input="updateField()"
            />
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-group">
            <label>Description</label>
            <!-- <input
              type="text"
              class="form-control"
              placeholder="Description"
              v-model.trim="description"
              @input="updateField()"
            /> -->
            <textarea class="form-control" @input="updateField()" v-model.trim="description" placeholder="Enter Description..." cols="30" rows="8"></textarea>
          </div>
        </div>

        <div class="col-md-4">
          <label class="d-block">Image</label>

          <div class="upload-card">
            <input type="file" accept="image/*" @change="onFileChange" />
            <div v-if="!image_url" class="default-state text-center">
              <svg class="upload-icon" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd"
                  d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm.5-10.5a.5.5 0 0 0-1 0V7H5a.5.5 0 0 0 0 1h2.5v2.5a.5.5 0 0 0 1 0V8H11a.5.5 0 0 0 0-1H8.5V4.5z"/>
              </svg>
              <div class="upload-hint text-muted">Upload Image</div>
            </div>

            <div v-else class="preview text-center px-2">
              <img :src="image_url" alt="Preview" />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Button Text</label>
            <input
              type="text"
              class="form-control"
              placeholder="Button Text"
              v-model.trim="button_text"
              @input="updateField()"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label>Button Link</label>
            <input
              type="text"
              class="form-control"
              placeholder="Button Link"
              v-model.trim="button_link"
              @input="updateField()"
            />
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group d-flex">
            <label>Show Always</label>
            <b-form-checkbox v-model="show_always" @change="updateField()" switch class="ml-2 mt-n2" />
          </div>
        </div>

        <div class="col-6" v-if="!show_always">
          <label for="date-start-select">Start Date</label>
          <VueCtkDateTimePicker
            id="startDatepicker"
            v-model="date_start"
            :color="$store.state.settings.colors.secondary"
            :button-color="$store.state.settings.colors.primary"
            :only-date="true"
            no-header
            noClearButton
            no-button-now
            label="Select Date"
            format="YYYY-MM-DD"
            formatted="ddd, MMM Do, YYYY" />
        </div>

        <div class="col-6" v-if="!show_always">
          <label for="date-end-select">End Date</label>
          <VueCtkDateTimePicker
            id="endDatepicker"
            v-model="date_end"
            :color="$store.state.settings.colors.secondary"
            :button-color="$store.state.settings.colors.primary"
            :only-date="true"
            no-header
            noClearButton
            no-button-now
            label="Select Date"
            format="YYYY-MM-DD"
            formatted="ddd, MMM Do, YYYY" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
export default {
  name: 'brandDepartmentPopupContent',

  props: {
    value: {
      type: Object,
      required: true
    },
    saving: {
      type: Boolean,
      default: false
    },
    showIfVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: this.value.visible,
      title: this.value.title,
      description: this.value.description,
      image_url: this.value.image_url,
      image_file: this.value.image_file,
      button_text: this.value.button_text,
      button_link: this.value.button_link,
      show_always: this.value.show_always,
      date_start: this.value.date_start,
      date_end: this.value.date_end
    };
  },
  created () {
    this.applyFromProp(this.value);
  },
  components: {
    VueCtkDateTimePicker
  },
  watch: {
    value: {
      deep: true,
      handler (v) { this.applyFromProp(v); }
    },
    show_always: function (newVal) {
      if (newVal) {
        this.date_start = null;
        this.date_end = null;
        this.updateField();
      }
    },
    date_start: function () {
      this.updateField();
    },
    date_end: function () {
      this.updateField();
    }
  },
  computed: {
    content () {
      return {
        visible: this.visible,
        title: this.title,
        description: this.description,
        image_url: this.image_url,
        image_file: this.image_file,
        button_text: this.button_text,
        button_link: this.button_link,
        show_always: this.show_always,
        date_start: this.date_start,
        date_end: this.date_end
      };
    }
  },
  methods: {
    applyFromProp (v) {
      this.visible = v.visible;
      this.title = v.title;
      this.description = v.description;
      this.image_url = v.image_url;
      this.image_file = v.image_file;
      this.button_text = v.button_text;
      this.button_link = v.button_link;
      this.show_always = v.show_always;
      this.date_start = v.date_start;
      this.date_end = v.date_end;
    },
    updateField () {
      this.$emit('input', this.content);
    },
    onFileChange (e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      this.image_file = file;
      this.updateField();

      const reader = new FileReader();
      reader.onload = (evt) => {
        this.image_url = evt.target.result;
        this.updateField();
      };
      reader.readAsDataURL(file);
      // allow same-file reselect later
      e.target.value = '';
    }
  }
};
</script>

<style scoped>
.upload-card{
  border: 2px dashed #ced4da;
  border-radius: .5rem;
  min-height: 180px;
  background: #f8f9fa;
  display: flex; align-items: center; justify-content: center;
  position: relative; text-align: center;
  transition: border-color .2s, background-color .2s;
}
.upload-card:hover{ border-color: #6c757d; background-color: #fff; }
.upload-card input[type=file]{ position:absolute; top:0; left:0; right:0; bottom:0; opacity:0; cursor:pointer; }
.upload-hint{ font-size:.9rem; }
.upload-icon{ display:block; margin:0 auto .5rem; width:36px; height:36px; color:#343a40; }
.preview img{ max-width:100%; max-height:160px; object-fit:contain; border-radius:.25rem; }
</style>
